var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3D7A94"
    },
    d: "M499.8,357.55c0-78.5-98.8-131.3-243.8-131.3s-243.8,52.8-243.8,131.3S111,488.85,256,488.85 S499.8,436.05,499.8,357.55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6BADB4"
    },
    d: "M75,222.15c0,58.3,73.3,97.5,181,97.5s181-39.2,181-97.5s-73.3-97.5-181-97.5S75,163.85,75,222.15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#83C7C3"
    },
    d: "M374.2,86.65c0,38-47.9,63.6-118.2,63.6s-118.2-25.6-118.2-63.6s47.9-63.6,118.2-63.6 S374.2,48.65,374.2,86.65z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000030"
    },
    d: "M464.4,268.75c-5.3-4.1-13-3.2-17.1,2.2c-4.1,5.3-3.1,13,2.2,17.1c25.3,19.6,38.1,43,38.1,69.6 c0,42.6-33.2,69.4-61.1,84.3c-42.3,22.7-101.3,34.8-170.5,34.8s-128.2-12-170.5-34.8c-27.9-15-61.1-41.8-61.1-84.3 c0-26.6,12.8-50,38.1-69.6c5.3-4.1,6.3-11.8,2.2-17.1c-4.1-5.3-11.8-6.3-17.1-2.2C16.5,292.85,0,323.55,0,357.55 c0,85.8,102.9,143.5,256,143.5s256-57.7,256-143.5C512,323.55,495.5,292.85,464.4,268.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000030"
    },
    d: "M256,331.75c115.5,0,193.2-44.1,193.2-109.6c0-34.6-22-64.5-62.1-84.1c-6-3-13.3-0.5-16.3,5.6 c-3,6-0.5,13.3,5.6,16.3c22.1,10.9,48.4,30.5,48.4,62.3c0,30.1-23.8,49.1-43.7,59.8c-30.5,16.4-74.9,25.4-125.1,25.4 s-94.6-9-125.1-25.4c-19.9-10.7-43.7-29.8-43.7-59.8c0-31.8,26.3-51.4,48.4-62.3c6-3,8.5-10.3,5.6-16.3c-3-6-10.3-8.5-16.3-5.6 c-40,19.7-62.1,49.5-62.1,84.1C62.8,287.75,140.5,331.75,256,331.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000030"
    },
    d: "M256,162.55c78,0,130.3-30.5,130.3-75.8s-52.4-75.8-130.3-75.8s-130.3,30.4-130.3,75.7 C125.7,132.05,178,162.55,256,162.55z M256,35.25c62.4,0,106,21.1,106,51.4s-43.6,51.4-106,51.4s-106-21.1-106-51.4 S193.6,35.25,256,35.25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000030"
    },
    d: "M312.6,61.85c-5.8,0-10.6,4.8-10.6,10.6s4.8,10.6,10.6,10.6s10.6-4.8,10.6-10.6 S318.4,61.85,312.6,61.85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000030"
    },
    d: "M134.2,239.05c-5.9,0-10.6-4.8-10.6-10.6s4.8-10.6,10.6-10.6s10.6,4.8,10.6,10.6 S140,239.05,134.2,239.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000030"
    },
    d: "M175.3,269.85c-5.9,0-10.6-4.8-10.6-10.6c0-5.9,4.8-10.6,10.6-10.6s10.6,4.8,10.6,10.6 C185.9,265.05,181.1,269.85,175.3,269.85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000030"
    },
    d: "M423.8,394.15c-5.8,0-10.6-4.8-10.6-10.6c0-5.9,4.8-10.6,10.6-10.6c5.9,0,10.6,4.8,10.6,10.6 C434.4,389.45,429.7,394.15,423.8,394.15z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRock);
export default __webpack_public_path__ + "static/media/rock.6bed4832f8ded11f8235376bff6cae69.svg";
export { ForwardRef as ReactComponent };